module.exports = __webpack_public_path__ + "img/live.fec4066.gif";